import React from "react";

export default props => {
  const className = props.event.id === undefined ? "bg-danger" : undefined;
  const style = props.event.id === undefined ? { color: "#3174ad" } : undefined;
  return (
    <div className={className} style={style}>
      {props.title}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/calendar/CustomEvent.js